import {
  LIBRARY_MODIFIER_ASK_DELETE_MODIFIER,
  LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER,
  LIBRARY_MODIFIER_DELETE_MODIFIER,
  LIBRARY_MODIFIER_MODIFIERS_REQUEST,
  LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS,
  LIBRARY_MODIFIER_ON_CLICK_CANCEL,
  LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER,
  LIBRARY_MODIFIER_ON_CLICK_ROW,
  LIBRARY_MODIFIER_PAGE_REQUEST,
  LIBRARY_MODIFIER_SUBMIT_FORM_CREATE,
  LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET,
  LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE,
  LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_FILL_MODIFIER_FORM,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST,
  LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM
} from 'actions/library/modifier/constants'
import {takeLatest, put, call} from 'redux-saga/effects'
import {initialize, arrayRemoveAll, arrayPush, change} from 'redux-form'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as actModifier from 'actions/library/modifier'
import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiModifier from 'api/modifiers'
import * as apiItems from 'api/items'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpLibraryModifier from 'mixpanel/library/modifier'

function * fillSearchFormFromProfile (profile) {
  let assignedOutletIds = []

  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

function * fillModifierFormFlow (request) {
  const {payload: {modifier}} = request

  let form = {
    id: modifier.id,
    name: modifier.name,
    options: modifier.active_options.map((modifier) => {
      let {id, name, price} = modifier
      price = price || price === 0 ? price.toString() : price
      return {id, name, price}
    })
  }
  yield put(initialize('modifier', form))
}

function * fillApplySetItemFormFlow (request) {
  const {payload: {modifier}} = request

  let form = {
    id: modifier.id,
    itemIds: modifier.active_item_modifiers.map((itemModifier) => {
      return itemModifier.item_id
    })
  }
  yield put(initialize('applySetItem', form))
}

function * emptyModifierFormFlow (request) {
  let form = {
    id: null,
    name: null,
    options: []
  }
  yield put(initialize('modifier', form))
}

function * openRightColumn () {
  yield put(actModifier.openRightColumn())
}

function * closeRightColumn () {
  yield put(actModifier.closeRightColumn())
}

export function * pageRequest () {
  // reset...
  yield put(actModifier.setModifiers([]))
  yield put(showPageLoadingSpinner(true))
  yield put(actModifier.setModifierDetail(null))
  yield put(actModifier.setOutlets([]))
  yield put(actModifier.closeRightColumn())
  yield put(act.showProgressBar())
  yield put(actModifier.emptyModifierForm())
  try {
    let response = yield call(apiOutlets.outlets)
    yield put(actModifier.setOutlets(response.data))

    let resProfile = yield call(apiProfile.getProfile)
    mpLibraryModifier.libraryModifierStart({
      current_outlet: resProfile.data.outlet_id[0]
    })

    yield call(fillSearchFormFromProfile, resProfile.data)

    let resModifier = yield call(apiModifier.getModifiers, {page: 1})
    let modifiers = resModifier.data.results
    yield put(actModifier.setModifiers(modifiers))
    yield put(actModifier.setTotalPage(resModifier.data.total_pages))
    yield put(actModifier.setCurrentPage(1))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * onClickApplySetItem (action) {
  const {payload: {modifier}} = action
  try {
    yield put(act.showProgressBar())

    // set apply item data
    {
      const resItems = yield call(apiItems.getItems, {})
      const {data} = resItems
      yield put(actModifier.applySetItemFillForm(modifier))
      yield put(actModifier.applySetItemSetCurrentPage(1))
      yield put(actModifier.applySetItemSetTotalPage(data.total_pages))
      yield put(actModifier.applySetItemSetItems(data.results))
      yield put(actModifier.showApplySetItem())
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * applySetItemItemsRequest (request) {
  const {payload: {params, previousItems}} = request
  try {
    yield put(act.showProgressBar())

    // set apply item data
    // if params contains keyword then we use other api
    // TODO the backend doesn't support pagination for search by keyword
    // so if we search with keyword, we cannot use pagination
    if (params && params.keyword) {
      // V1 API includes params with_batch to support pagination
      params.with_batch = true
      const resItems = yield call(apiItems.getItemsV1, params)
      const {data} = resItems
      yield put(actModifier.applySetItemSetCurrentPage(1))
      // set total page to 1 since V1 API doesn't support pagination
      yield put(actModifier.applySetItemSetTotalPage(1))
      let items = data.results
      yield put(actModifier.applySetItemSetItems(items))
    } else {
      const resItems = yield call(apiItems.getItems, params)
      const {data} = resItems
      yield put(actModifier.applySetItemSetCurrentPage(params.page))
      yield put(actModifier.applySetItemSetTotalPage(data.total_pages))
      let items = previousItems.concat(data.results)
      yield put(actModifier.applySetItemSetItems(items))
    }
    yield put(actModifier.showApplySetItem())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * cancelApplySetItem () {
  yield put(actModifier.hideApplySetItemModal())
}

export function * confirmApplySetItem (request) {
  const {payload: {data, modifierId}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actModifier.hideApplySetItemModal())
    yield call(apiModifier.postApplyToItems, modifierId, data)
    yield put(actModifier.setModifierDetail(null))
    yield call(closeRightColumn)
    let resModifier = yield call(apiModifier.getModifiers, {page: 1})
    let modifiers = resModifier.data.results
    yield put(actModifier.setModifiers(modifiers))
    yield put(actModifier.setTotalPage(resModifier.data.total_pages))
    yield put(actModifier.setCurrentPage(1))
    yield put(actNotif.success('Successfully applied modifier'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * modifiersRequest (action) {
  const {payload: {params, previousModifiers}} = action
  yield put(act.showProgressBar())

  try {
    let response = yield call(apiModifier.getModifiers, params)
    let modifiers = previousModifiers.concat(response.data.results)
    yield put(actModifier.setModifiers(modifiers))
    yield put(actModifier.setTotalPage(response.data.total_pages))
    yield put(actModifier.setCurrentPage(params.page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onChangeOutletIds (action) {
  yield put(actModifier.setModifiers([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds}} = action
  try {
    yield put(act.showProgressBar())
    yield call(closeRightColumn)
    yield call(apiOutlets.patchLogin, {id: outletIds})
    const res = yield call(apiModifier.getModifiers, {page: 1})
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    yield put(actModifier.emptyModifierForm())
    yield put(actModifier.setModifiers(res.data.results))
    yield put(actModifier.setTotalPage(res.data.total_pages))
    yield put(actModifier.setCurrentPage(1))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * clickModifierRow (request) {
  {
    let {payload: {modifier}} = request
    try {
      yield put(act.showProgressBar())

      let res = yield call(apiModifier.getModifierById, modifier.id)
      yield put(actModifier.setModifierDetail(res.data))
      yield put(actModifier.fillModifierForm(res.data))
      yield call(openRightColumn)
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.hideProgressBar())
    }
  }
}

export function * submitFormCreate (request) {
  let {payload: {data, previousModifiers}} = request

  if (data.modifier.options.length === 0) {
    yield put(actNotif.error('Please save at least one option'))
  } else {
    let dataPayload = data
    dataPayload.modifier.options = data.modifier.options.map((datum) => {
      if (datum.price) {
        return datum
      } else {
        return {...datum, price: null}
      }
    })
    yield put(act.showProgressBar())
    yield put(actModifier.isSubmittingForm(true))
    try {
      let response = yield call(apiModifier.postModifier, dataPayload)
      // set to reducers
      let modifier = response.data
      const modifiers = [modifier]
      previousModifiers.forEach(g => modifiers.push(g))

      yield put(actNotif.success('Modifier successfully created.'))
      yield put(actModifier.setModifiers(modifiers))
      yield put(actModifier.setModifierDetail(modifier))
      yield put(actModifier.fillModifierForm(modifier))
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.hideProgressBar())
      yield put(actModifier.isSubmittingForm(false))
    }
  }
}

export function * submitFormCreateAllOutlet (request) {
  let {payload: {data, previousModifiers}} = request
  if (data.modifier.options.length === 0) {
    yield put(actNotif.error('Please save at least one option'))
  } else {
    yield put(act.showProgressBar())
    yield put(actModifier.isSubmittingForm(true))
    try {
      let response = yield call(apiModifier.postCreateAllOutlet, data)
      // set to reducers
      let modifier = response.data
      const modifiers = [modifier]
      previousModifiers.forEach(g => modifiers.push(g))

      yield put(actNotif.success('Modifiers successfully created.'))
      yield put(actModifier.setModifiers(modifiers))
      yield put(actModifier.setModifierDetail(modifier))
      yield put(actModifier.fillModifierForm(modifier))
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.hideProgressBar())
      yield put(actModifier.isSubmittingForm(false))
    }
  }
}

export function * submitFormUpdate (request) {
  let {payload: {data, modifierId, previousModifiers}} = request
  if (data.modifier.options.length === 0) {
    yield put(actNotif.error('Please save at least one option'))
  } else {
    yield put(act.showProgressBar())
    yield put(actModifier.isSubmittingForm(true))
    try {
      let response = yield call(apiModifier.putModifier, modifierId, data)
      // set to reducers
      let modifier = response.data
      const modifiers = []
      previousModifiers.forEach(g => {
        if (g.id === modifierId) {
          modifiers.push(modifier)
        } else {
          modifiers.push(g)
        }
      })

      yield put(actNotif.success('Modifier successfully updated.'))
      yield put(actModifier.setModifiers(modifiers))
      yield put(actModifier.setModifierDetail(modifier))
      yield put(actModifier.fillModifierForm(modifier))
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.hideProgressBar())
      yield put(actModifier.isSubmittingForm(false))
    }
  }
}

export function * deleteModifier (request) {
  let {payload: {modifierId, previousModifiers}} = request
  yield put(act.showProgressBar())
  try {
    yield call(apiModifier.deleteModifier, modifierId)
    // set to reducers

    const modifiers = []
    previousModifiers.forEach((g) => {
      if (g.id !== modifierId) {
        modifiers.push(g)
      }
    })
    yield put(actModifier.setModifiers(modifiers))
    yield put(actModifier.setModifierDetail(null))
    yield put(actModifier.setDeletedModifier(null))
    yield put(actModifier.hideDeleteModifierModal())
    yield call(closeRightColumn)
    yield put(actModifier.fillModifierForm({id: null, amount: null, quantity: null, active_options: []}))

    yield put(actNotif.success('Modifier successfully deleted.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * clickCancel () {
  yield put(actModifier.setModifierDetail(null))
  yield put(actModifier.emptyModifierForm())
  yield call(closeRightColumn)
}

export function * clickCreateModifier () {
  yield put(actModifier.setModifierDetail(null))
  yield put(actModifier.emptyModifierForm())
  yield call(openRightColumn)
}

export function * askDeleteModifier (request) {
  const {payload: {deletedModifier}} = request
  yield put(actModifier.setDeletedModifier(deletedModifier))
  yield put(actModifier.showDeleteModifierModal())
}

export function * cancelDeleteModifier () {
  yield put(actModifier.setDeletedModifier(null))
  yield put(actModifier.hideDeleteModifierModal())
}

export function * onClickManageModifierOptions (request) {
  const {payload: {previousModifierForm}} = request
  yield put(actModifier.showModifierOptionsModal())
  yield put(actModifier.setPreviousModifierForm(previousModifierForm))
}

export function * onCancelManageModifierOptions (request) {
  const {payload: {previousModifierForm}} = request
  yield put(arrayRemoveAll('modifier', 'options'))
  for (let idx = 0; idx < previousModifierForm.options.length; idx++) {
    yield put(arrayPush('modifier', 'options', previousModifierForm.options[idx]))
  }
  yield put(actModifier.hideModifierOptionsModal())
}

export function * onConfirmManageModifierOptions (request) {
  const {options} = request.payload
  if (options.length === 0) {
    yield put(actNotif.error('Please save at least one option.'))
  }
  yield put(actModifier.hideModifierOptionsModal())
}

export default function * saga () {
  yield takeLatest(LIBRARY_MODIFIER_PAGE_REQUEST, pageRequest)
  yield takeLatest(LIBRARY_MODIFIER_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(LIBRARY_MODIFIER_MODIFIERS_REQUEST, modifiersRequest)
  yield takeLatest(LIBRARY_MODIFIER_ON_CLICK_CANCEL, clickCancel)
  yield takeLatest(LIBRARY_MODIFIER_ON_CLICK_ROW, clickModifierRow)
  yield takeLatest(LIBRARY_MODIFIER_SUBMIT_FORM_CREATE, submitFormCreate)
  yield takeLatest(LIBRARY_MODIFIER_ON_CLICK_CREATE_MODIFIER, clickCreateModifier)
  yield takeLatest(LIBRARY_MODIFIER_DELETE_MODIFIER, deleteModifier)
  yield takeLatest(LIBRARY_MODIFIER_ASK_DELETE_MODIFIER, askDeleteModifier)
  yield takeLatest(LIBRARY_MODIFIER_SUBMIT_FORM_UPDATE, submitFormUpdate)
  yield takeLatest(LIBRARY_MODIFIER_CANCEL_DELETE_MODIFIER, cancelDeleteModifier)
  yield takeLatest(LIBRARY_MODIFIER_SUBMIT_FORM_CREATE_ALL_OUTLET, submitFormCreateAllOutlet)
  yield takeLatest(LIBRARY_MODIFIER_ON_CLICK_APPLY_SET_ITEM, onClickApplySetItem)
  yield takeLatest(LIBRARY_MODIFIER_CANCEL_APPLY_SET_ITEM, cancelApplySetItem)
  yield takeLatest(LIBRARY_MODIFIER_CONFIRM_APPLY_SET_ITEM, confirmApplySetItem)
  yield takeLatest(LIBRARY_MODIFIER_APPLY_SET_ITEM_FILL_FORM, fillApplySetItemFormFlow)
  yield takeLatest(LIBRARY_MODIFIER_APPLY_SET_ITEM_ITEMS_REQUEST, applySetItemItemsRequest)
  yield takeLatest(LIBRARY_MODIFIER_FILL_MODIFIER_FORM, fillModifierFormFlow)
  yield takeLatest(LIBRARY_MODIFIER_EMPTY_MODIFIER_FORM, emptyModifierFormFlow)
  yield takeLatest(LIBRARY_MODIFIER_ON_CLICK_MANAGE_MODIFIER_OPTIONS, onClickManageModifierOptions)
  yield takeLatest(LIBRARY_MODIFIER_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS, onConfirmManageModifierOptions)
  yield takeLatest(LIBRARY_MODIFIER_ON_CANCEL_MANAGE_MODIFIER_OPTIONS, onCancelManageModifierOptions)
}



// WEBPACK FOOTER //
// ./app/sagas/library/modifier.js